/**
 * Base URL axios (sans suffixe /api).
 * - localhost → '' + proxy vue.config.js
 * - domaines publics / *.azurestaticapps.net → PATRIMONEA_API_ORIGIN (appel direct
 *   cross-origin vers le gateway ; la SWA n'a pas de linked backend pour proxifier
 *   /api en same-origin, cf. CORS_ALLOWED_ORIGINS côté gestion)
 */
export const PATRIMONEA_API_ORIGIN = 'https://patrimonea-ms.azurewebsites.net';

function browserHostname() {
  if (typeof window === 'undefined' || !window.location) return '';
  return String(window.location.hostname || '').toLowerCase();
}

export function isLocalDevHost(hostname = browserHostname()) {
  const h = String(hostname || '').toLowerCase();
  return !h || h === 'localhost' || h === '127.0.0.1';
}

export function resolveApiBaseUrl() {
  const fromEnv =
    typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_BASE_URL;
  if (fromEnv) return String(fromEnv).replace(/\/$/, '');

  const host = browserHostname();
  if (isLocalDevHost(host)) return '';

  if (
    /\.patrimoneabygwem\.com$/i.test(host) ||
    host === 'patrimoneabygwem.com' ||
    /\.azurestaticapps\.net$/i.test(host)
  ) {
    return PATRIMONEA_API_ORIGIN;
  }

  return '';
}

/** Préfixe pour appels axios manuels (ex. inscription) : origine BFF + /api */
export function resolveApiPrefix() {
  const base = resolveApiBaseUrl();
  if (!base) return '/api';
  return `${base.replace(/\/$/, '')}/api`;
}

/**
 * Résout une URL backend relative (ex. "/api/signatures/12/file/") en URL absolue,
 * pour une navigation directe (<a href>, window.open). Nécessaire car ces liens ne
 * passent pas par axios.defaults.baseURL et se résolvent sinon contre l'origine du
 * frontend (SWA) plutôt que celle du gateway — cause du « page introuvable ».
 */
export function resolveBackendUrl(path) {
  const p = String(path || '').trim();
  if (!p || /^https?:\/\//i.test(p)) return p;
  const base = resolveApiBaseUrl();
  if (!base) return p;
  return `${base.replace(/\/$/, '')}${p.startsWith('/') ? '' : '/'}${p}`;
}
